/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Implements the header hover menus

namespace('Slzr.Menus', function(exports, top) {
  const $ = Slzr.jQuery;

  // Base menu functionality
  class BaseMenu {
    // Initialize the basic menu functions
    //
    // This fires menu:open and menu:close events on the anchor element when the menu is shown or hidden
    //
    // If data-menu-reparent is set to true on menu_element,
    //
    // anchor_element: the element which displays the menu
    // menu_element: the element containing the menu items (this is hidden/shown)
    constructor(anchor_element, menu_element) {
      this.menu_element = $(menu_element);
      this.anchor_element = $(anchor_element);
      this.menu_shown = false;
      this.needs_select_fix = navigator.userAgent.match(/MSIE [56]/);
      this.move_to_body = (this.menu_element.data('menu-reparent') != null) ? this.menu_element.data('menu-reparent') : false;
      if (this.move_to_body === 'true') { this.move_to_body = true; }
      if (this.move_to_body === 'false') { this.move_to_body = false; }

      // Set up initial state of menus (positioned and hidden)
      this.menu_element.width(this.menu_element.width() + 1);
      this.positionMenu();
      this.hideMenu();

      // Reposition menus if the window gets resized
      $(window).resize(() => this.positionMenu());

      // Fix IE under select stuff
      if (this.needs_select_fix) { this.setupIESelectFix(); }
    }

    // Show the menu
    showMenu() {
      // Don't show the menu on small devices (phones)
      if (document.width <= 767) { return; }

      this.menu_shown = true;

      // Move to end of BODY, and insert marker to return
      if (this.move_to_body) {
        this.original_position = $('<!-- menu placeholder -->');
        this.menu_element.before(this.original_position);
        this.menu_element.appendTo(document.body);
      }

      this.menu_element.show();
      this.positionMenu();
      $(this.anchor_element).addClass('open').attr('aria-expanded', 'true');
      $(this.anchor_element).trigger('menu:open', [this]);
      return this.showIESelectFix();
    }

    // Hide the menu
    hideMenu() {
      this.menu_shown = false;
      this.menu_element.hide();
      $(this.anchor_element).removeClass('open').attr('aria-expanded', 'false');
      $(this.anchor_element).trigger('menu:close', [this]);
      this.hideIESelectFix();

      if (this.move_to_body && this.original_position) {
        // Move it back to the original position
        this.menu_element.insertBefore(this.original_position);
        this.original_position.remove();
        return this.original_position = null;
      }
    }


    // Setup the IE SELECT fix (for IE5/6)
    //
    // Creates an empty IFRAME that gets positioned underneath the menu
    setupIESelectFix() {
      if (this.ie_frame_fix == null) { this.ie_frame_fix = $('<iframe/>'); }
      return this.ie_frame_fix
        .attr({src:'javascript:false;', zsrc: 'javascript:void;', frameborder: 0, tabindex: -1})
        .css({display: 'block', position: 'absolute', zIndex: 9999});
    }

    // Positions and displays the IE SELECT iframe shim
    showIESelectFix() {
      if (this.needs_select_fix && this.ie_frame_fix) {
        // Get the size and position of the dropdown element
        const position         = this.menu_element.offset();
        const height           = this.menu_element.outerHeight(true);
        const width            = this.menu_element.outerWidth(true);

        return this.ie_frame_fix
          .show()
          .insertBefore(this.menu_element)
          .offset(position)
          .height(height)
          .width(width);
      }
    }

    // Hide the IE SELECT fix by removing it from DOM
    hideIESelectFix() { if (this.needs_select_fix) { return $(this.ie_frame_fix).hide(); } }

    selfHorizontalPadding() { return this.menu_element.innerWidth() - this.menu_element.width(); }

    // Size and position menu_element below the anchor item
    //
    // Options:
    //  alignment: How to horizontally align the menu relative to anchor_el ('center' or 'left')
    //  width: The width of the list element, can be 'full' to match the sizing of the dropdown-menu
    positionMenu(options) {
      let at_position; let my_position; let width;
      if (options == null) { options = {}; }
      if (!options.alignment) { options.alignment = 'left'; }
      if (this.menu_element.data('menu-alignment') != null) { options.alignment = this.menu_element.data('menu-alignment'); }
      if (!options.verticalAlignment) { options.verticalAlignment = 'bottom'; }
      if (this.menu_element.data('menu-vertical-alignment') != null) { options.verticalAlignment = this.menu_element.data('menu-vertical-alignment'); }
      if (this.menu_element.data('menu-width') != null) { options.width = this.menu_element.data('menu-width'); }
      if (this.menu_element.data('text-alignment') != null) { options.textAlignment = this.menu_element.data('text-alignment'); }
      
      const menuName = this.menu_element.data('dropdown-menu');

      if (options.width === 'full') {
        // adjust full width by subtracting padding, otherwise the element may be longer than the parent
        width = $(`[data-dropdown='${menuName}']`).outerWidth() - this.selfHorizontalPadding();
      } else {
        width = this.menu_element.width();
      }

      if (options.alignment === 'center') {
        my_position = 'center top';
        at_position = 'center bottom';
      } else if (options.alignment === 'left') {
        my_position = 'left top';
        at_position = 'left bottom';
      } else if (options.alignment === 'right') {
        my_position = 'right top';
        at_position = 'right bottom';
      }

      // Flip top/bottom if a top-aligned menu
      if (options.verticalAlignment === 'top') {
        [my_position, at_position] = Array.from([at_position, my_position]);
      }

      return this.menu_element
        .css({position: 'absolute', textAlign: options.textAlignment})
        .position({
          my: my_position,
          at: at_position,
          of: this.anchor_element,
          collision: "flipfit flip"}).width(width);
    }
  }

  // Hover menu functionality
  class HoverMenu extends BaseMenu {
    // Initialize a hover menu, and attach hide/show handlers to hover events
    constructor(anchor_element, menu_element) {
      super(anchor_element, menu_element);
      this.mouseover = this.mouseover.bind(this);
      this.mouseout = this.mouseout.bind(this);
this.hideTimerFired = this.hideTimerFired.bind(this);
      this.hide_timer = null;

      $(this.anchor_element)
        .add(this.menu_element)
        .mouseover(this.mouseover)
        .focusin(this.mouseover)
        .mouseout(this.mouseout)
        .focusout(this.mouseout);
    }

    // Event handler for showing the menu
    mouseover() {
      if (!this.menu_shown) { this.showMenu(); }
      clearTimeout(this.hide_timer);
      return this.hide_timer = null;
    }

    // Event handler to hide the menu
    mouseout() {
      if (this.menu_shown && !this.hide_timer) {
        return this.hide_timer = setTimeout(this.hideTimerFired, 0);
      }
    }

    // Callback to hide
    hideTimerFired() {
      this.hide_timer = null;
      return this.hideMenu();
    }
  }


  // Click-to-display menu
  class ClickMenu extends BaseMenu {
    constructor(anchor_element, menu_element) {
      super(anchor_element, menu_element);
this.click = this.click.bind(this);

      $(this.anchor_element)
        .add(this.menu_element)
        .click(this.click);
    }

    // Event handler for toggling menu
    click(ev) {
      if (this.menu_shown) {
        // Defer a moment, to allow Firefox to activate a file INPUT
        setTimeout((() => this.hideMenu()), 0);
        $(document).off('.clickMenu');
        return true;
      } 
        this.showMenu();

        // Attach handler for clicks elsewhere on the page
        const child_elements = $(this.anchor_element).add(this.menu_element).add(this.anchor_element.children()).add(this.menu_element.children());
        return $(document).on('click.clickMenu', evt => {
          if ($(evt.target).not(child_elements).length > 0) {
            // Defer the hide a moment to fix Firefox
            return setTimeout((() => this.hideMenu()), 0);
          }
        });
      
    }
  }

  // Make everything available globally
  return (() => {
    const result = [];
    const object = {
    BaseMenu,
    HoverMenu,
    ClickMenu
  };
    for (const key in object) {
      const value = object[key];
      result.push(exports[key] = value);
    }
    return result;
  })();
});

Slzr.jQuery(function($) {
  // Automatically enable any hover menus
  $('.hover_menu').each(function() {
    return new Slzr.Menus.HoverMenu(this, $(`#${this.id}-list`));
  });

  // Automatically enable click menus
  $('[data-dropdown]').each(function() {
    const menu_name = $(this).data('dropdown');
    const menu_contents = $(`[data-dropdown-menu='${menu_name}']`);
    return new Slzr.Menus.ClickMenu(this, menu_contents);
  });

  // Fix IE z-index issues with the hover menus, by forcing a high z-index on all the element's
  // ancestors
  if (navigator.userAgent.match(/MSIE [567]/)) {
    return $('.action_menu, .action_menu_items').each(function() {
      return $(this).parents().each(function() {
        const p = $(this);
        const pos = p.css('position');

        if ((pos === 'relative') || (pos === 'absolute') || (pos === 'fixed')) { return p.css({zIndex: 99999}); }
      });
    });
  }
});
